export default __webpack_public_path__ + "static/media/AIA_ANNUITY_FIX.60e19314.png";